import { Box, Toolbar } from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { T3_LOGO } from "../constants";
import style from "./header.module.css";

const Header = (props) => {
  const navigate = useNavigate();
  const { header, bgColor, navigateRoute, canGoBack = true, canRedirectToHome = true } = props;

  const handleBackButton = () => {
    navigateRoute ? navigateRoute() : navigate(-1);
  };
  return (
    <Box
      className={style.container}
      style={{ backgroundColor: bgColor ? bgColor : "",  }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          {canGoBack && (
            <IoIosArrowBack
              className={style.backArrowIcon}
              onClick={handleBackButton}
            />
          )}
          <h4 className={style.header}>{header}</h4>
        </Box>
        <Box>
          <img src={T3_LOGO} onClick={canRedirectToHome ? () => navigate("/" ) : undefined} />
        </Box>
      </Toolbar>
    </Box>
  );
};

export default Header;
